<template>
  <div class="container-fluid login">
    <div class="row">
      <div class="col-12 col-md-12 col-lg-5 d-flex align-items-center flex-column info">
        <div class="logo">
          <a :href="lpUrl" class="ico-iouu" target="_blank" title="IOUU"></a>
        </div>
        <div class="row justify-content-center d-flex align-items-center">
          <div class="col-12 col-lg-10 d-flex flex-column align-items-center">
          <h1>Cadastrar senha</h1>
            <p>
              Não se preocupe. Você não está assumindo nenhum compromisso neste momento.
              <br/>Suas informações serão usadas paenas para analisarmos o seu perfil
            </p>
            <p>
              Através da plataforma, você poderá enviar todos os documentos solicitados, fazer investimentos e solicitar empréstimo.
            </p>
            <p>
              O empréstimo só acontece se você receber uma proposta, aprová-la e fizer o upload da documentação pedida no site.
            </p>   
          </div> 
        </div>
        <social-network/>
      </div>
      <div class="col-12 col-md-12 col-lg-7 d-flex flex-column form">
        <header class="align-self-center align-self-md-end">
        Já tem uma conta?
          <router-link to="login" class="btn btn-outline-primary">Entrar</router-link>
        </header>
        <div class="row justify-content-center d-flex align-items-center">
          <div class="col-12 col-md-8 col-lg-5 text-center">
            <h2>Cadastrar senha</h2>
            <form id="form-cadastrarSenha" @submit.prevent="signUp">
              <div class="form-group text-left">
                <label for="name">Nome</label>
                <input type="text" name="firtname" class="form-control form-control-lg" v-model="name" autofocus>
              </div>
              <div class="form-group text-left">
                <label for="email">Endereço de email</label>
                <input type="email" class="form-control form-control-lg" placeholder="Endereço de email do usuário…" v-model="email" readonly>
              </div>
              <div class="form-group text-left">
                <label for="password">Senha</label> 
                <password-field v-model="password"/>
              </div>

              <div class="form-check text-left d-flex justify-content-center">
                <div class="checkboxContainer">
                  <input class="form-check-input" type="checkbox" v-model="enabled">
                  <span class="checkmark"></span>
                </div>
                <div>
                  <label class="form-check-label">
                    Eu "CONCORDO" com os <a :href="lpUrl+'/termos-e-condicoes/'" target="_blank">Termos e condições</a> e <a :href="lpUrl+'/politica-de-privacidade/'" target="_blank">Política de privacidade</a> da IOUU.
                  </label>
                </div>
              </div>
                <button class="btn btn-lg btn-primary" :disabled="!enabled">Continuar</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  @import "../assets/styles/iouu/_variables";
  @import '../assets/styles/iouu/_mixins.scss';

  .form-check-label {
    &{
      padding-left: 0;
    }

    @include xs {
      padding-left: 10px;
    }
  }

   // CHECKBOX - CUSTOM 
	.checkboxContainer {
		&{
		  display: block;
		  position: relative;
		  cursor: pointer;
		  -webkit-user-select: none;
		  -moz-user-select: none;
		  -ms-user-select: none;
			user-select: none;
			width: 25px;
			height: 25px;
			margin-right: 10px;
    }
    
		&:hover {
		  input ~ .checkmark {
			background-color: #ccc;
		  }
		}
	
		input {
		  position: absolute !important;
		  opacity: 0;
		  width: 25px;
		  height: 25px;
		  cursor: pointer;
			left: 0;
      margin-left: 0;
      top: -4px;
	
		  &:checked ~ .checkmark {
			background-color: #41D3BF;
		  }
		}
	
		.checkmark {
		  position: absolute;
		  top: -4px;
		  left: 0;
		  height: 25px;
		  width: 25px;
		  background-color: #eee;
		  border-radius: 6px;
		  cursor: pointer;
		  pointer-events: none;
	
		  &::after {
			content: "";
			position: absolute;
			display: none;
			left: 9px;
			top: 5px;
			width: 8px;
			height: 13px;
			border: solid white;
			border-width: 0 3px 3px 0;
			-webkit-transform: rotate(45deg);
			-ms-transform: rotate(45deg);
			transform: rotate(45deg);
		  }
	
		}
	
		input:checked ~ .checkmark:after {
		  display: block;
		}
	}
	// END CHECKBOX - CUSTOM

  .login {
    .info {
      background:url(/static/assets/images/bg-login.jpg) top center no-repeat, linear-gradient(to bottom right, $c3, $c2 85%);
      background-size: cover;
      // background-blend-mode: multiply;
      text-align: center;
      color: #fff;
    }

    .form {
      h2 {
        padding-bottom: 40px;
      }
    }
  }
</style>

<script>
import ApiClient from '../utils/api-client'
import SocialNetwork from '../components/SocialNetwork'
import ArrayHelper from '@/utils/array-helper'
import PasswordField from '@/components/PasswordField'

export default {
  data() {
    return {
      lpUrl:process.env.LP_URL,
      name: '',
      email: '',
      password: '',
      enabled: false
    }
  },
  components: {
    SocialNetwork, PasswordField
  },
  methods: {
    signUp() {
      this.$store.dispatch('signup', {name: this.name, email: this.email, password: this.password})
        .then(() => this.$router.push("/"))
        .catch(error => {
          const errorMessages = error.response.data.errors.map(error => error.detail)
          this.$Notify.error(ArrayHelper.toSentence(errorMessages))
        })
      fbq('track', 'Lead', {userID: email}); //PIXEL DO FACEBOOK
    },
    facebookLogin(e) {
      e.preventDefault()
      ApiClient.get('oauth/facebook/url')
        .then(response => {
          window.location.href = response.data.loginUrl
        })
    },
    googleLogin(e) {
      e.preventDefault()
      ApiClient.get('oauth/google/url')
        .then(response => {
          window.location.href = response.data.loginUrl
        })
    },
    linkedinLogin(e) {
      e.preventDefault()
      ApiClient.get('oauth/linkedin/url')
        .then(response => {
          window.location.href = response.data.loginUrl
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/CadastrarSenhaUsuario.vue